module.exports = __webpack_public_path__ + "static/media/csv-down.4572acbe.svg";